import { useIsProcessing } from "../lib/hooks/useIsProcessing";

export function useIsThinking() {
  const isProcessing = useIsProcessing();

  return {
    agentIsThinking: isProcessing,
  };
}
